import React from "react";
import "./LandingPage.css";
import VerifiedExpertBacked from "../images/LandingPage/VerifiedExpertBacked.svg";
import DailyInstaSwingRecommendations from "../images/LandingPage/DailyInstaSwingRecommendations.svg";
import AvgSuccessrate from "../images/LandingPage/AvgSuccessrate.svg";
import CryptoCoinsCovered from "../images/LandingPage/CryptoCoinsCovered.svg";
import CryptooAntsPremiumIcon from "../images/LandingPage/CryptooAntsPremiumIcon.svg";
import CryptoBuzzIcon from "../images/LandingPage/CryptoBuzzIcon.svg";
import CryptooAntsPremiumImage from "../images/LandingPage/CryptooAntsPremiumImage.svg";
import CryptoBuzzImage from "../images/LandingPage/CryptoBuzzImage.svg";
import VerifiedCryptoExperts from "../images/LandingPage/VerifiedCryptoExperts.svg";
import HumanAIPrecision from "../images/LandingPage/HumanAIPrecision.svg";
import InstantAlert from "../images/LandingPage/InstantAlert.svg";
import RealTimerecommendationtracking from "../images/LandingPage/RealTimerecommendationtracking.svg";
import avatar from "../images/LandingPage/avatar.svg";
import rightArrow from "../images/LandingPage/rightArrow.svg";
import icon3 from "../images/LandingPage/icon3.svg";
import icon4 from "../images/LandingPage/icon4.svg";
import aboutGroup from "../images/LandingPage/aboutGroup.png";
import Footerimg from "../images/LandingPage/Footerimg.svg";
import facebook from "../images/LandingPage/facebook.png";
import instagram from "../images/LandingPage/instagram.png";
import linkedin from "../images/LandingPage/linkedin.png";
import twitter1 from "../images/LandingPage/twitter 1.png";
import LaptopMockup from "../images/LandingPage/LaptopMockup.svg";
import LaptopMockups from "../images/LandingPage/LaptopMockups.svg";
import gmail from "../images/LandingPage/gmail.svg";

export default function LandingPage() {
  return (
    <div className="landing-wrapper">

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container hero-content">
          <div className="row align-items-center">

            <div className="col-md-6">
              <h1 className="hero-title">
                Marketplace For <br />
                <span className="highlight">Crypto Price Estimates</span>
              </h1>

              <p className="hero-subtitle">
                Get Access To Verified Crypto Experts Price Estimates
              </p>

              <button className="btn btn-primary custom-btn">
                Coming Soon...
              </button>
            </div>

          <div className="col-md-6 text-center laptop-wrapper">
  <img
    src={LaptopMockups}
    alt="Laptop"
    className="laptop-img"
  />

  <div className="video-frame">
    <iframe
      src="https://www.youtube.com/embed/K175ByNOmuA?autoplay=1&mute=1&controls=0&modestbranding=1&showinfo=0&rel=0&playsinline=1&loop=1&playlist=K175ByNOmuA"
      title="YouTube video"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>
</div>

          </div>
        </div>
      </section>

      {/* WHY SECTION */}
      <section className="why-section">
        <div className="container text-center">

          <h2 className="why-title">
            Why <span className="highlight">CryptooAnts</span>
          </h2>

          <p className="why-desc">
            CryptooAnts Is A Marketplace For Crypto Price Estimates That Bridges Verified
            Crypto Experts Price Estimate With Crypto Exchange And Trading Apps.
            We Help Retail Trader/Investor Make Informed Decision By Aggregating And
            Tracking Real Time Crypto Insights.
          </p>

          <p className="why-desc mt-3">
            Our Goal Is To Cut The Noise And Help Busy Professionals To Participate
            In Crypto With Ease By Supporting With Verified Experts Ready To Use
            Crypto Price Estimates.
          </p>

          {/* FEATURE CARDS */}
         <div className="row feature-row mt-5">

  {/* CARD 1 */}
  <div className="col-md-3 mb-4">
    <div className="feature-card">
      <img src={VerifiedExpertBacked} alt="Verified Expert" className="feature-icon-img" />

      <h5 className="feature-title">Verified Expert Backed</h5>

      <p className="feature-text">
        Access insight from Certified Crypto Expert
      </p>
    </div>
  </div>

  {/* CARD 2 */}
  <div className="col-md-3 mb-4">
    <div className="feature-card">
      <img src={HumanAIPrecision} alt="AI Precision" className="feature-icon-img" />

      <h5 className="feature-title">Human + AI Precision</h5>

      <p className="feature-text">
        Achieve 60% and above success with Crypto Expert
      </p>
    </div>
  </div>

  {/* CARD 3 */}
  <div className="col-md-3 mb-4">
    <div className="feature-card">
      <img src={InstantAlert} alt="Instant Alert" className="feature-icon-img" />

      <h5 className="feature-title">Instant Alert</h5>

      <p className="feature-text">
        Get instant alerts on new recommendation Target & Stoploss
      </p>
    </div>
  </div>

  {/* CARD 4 */}
  <div className="col-md-3 mb-4">
    <div className="feature-card">
      <img src={RealTimerecommendationtracking} alt="Real Time" className="feature-icon-img" />

      <h5 className="feature-title">Real Time Tracking</h5>

      <p className="feature-text">
        Get price estimate in structured format with real time tracking
      </p>
    </div>
  </div>

</div>

        </div>
      </section>

{/* OUR PRODUCTS SECTION */}
<section className="products-section">
  <h2 className="section-title">Our Products</h2>
  <div className="section-divider"></div>

  {/* PRODUCT 1 */}
  <div className="product-block">
    <img src={CryptooAntsPremiumIcon} alt="icon" className="product-icon" />
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}><h1 className="product-number">01</h1><h3 className="product-name">CryptooAnts Premium</h3></div>
    <p className="product-desc">
      CryptooAnts Premium is an advanced module where verified experts can publish
      crypto price recommendations (supports 1–day, intraday, swing & quant type).
    </p>
    <img src={CryptooAntsPremiumImage} alt="Product" className="product-img" />
  </div>

  {/* PRODUCT 2 */}
  <div className="product-block">
    {/* <h1 className="product-number blue">02</h1> */}
    <img src={CryptoBuzzIcon} alt="icon" className="product-icon" />
     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}><h1 className="product-number">02</h1><h3 className="product-name">CryptooBuzz</h3></div>
    <p className="product-desc">
      CryptooBuzz is an in-depth research dashboard where experts publish news,
      updates, market insights & on-chain analysis.
    </p>
    <img src={CryptoBuzzImage} alt="Product" className="product-img" />
  </div>
</section>

{/* PLATFORM ACHIEVEMENTS SECTION */}
<section className="achievements-section">
  <h2 className="achievements-title">Platform Achievements</h2>

  <div className="container">
    <div className="row text-center achievement-row">

      <div className="col-md-3 mb-4">
        <div className="achievement-card">
          <img src={VerifiedCryptoExperts} className="ach-icon" alt="" />
          <h3 className="ach-count">+40</h3>
          <p className="ach-text">Verified Crypto Experts</p>
        </div>
      </div>

      <div className="col-md-3 mb-4">
        <div className="achievement-card">
          <img src={DailyInstaSwingRecommendations} className="ach-icon" alt="" />
          <h3 className="ach-count">+15</h3>
          <p className="ach-text">Daily Insta & Swing Recommendations</p>
        </div>
      </div>

      <div className="col-md-3 mb-4">
        <div className="achievement-card">
          <img src={AvgSuccessrate} className="ach-icon" alt="" />
          <h3 className="ach-count">50~60%</h3>
          <p className="ach-text">Avg Success rate</p>
        </div>
      </div>

      <div className="col-md-3 mb-4">
        <div className="achievement-card">
          <img src={CryptoCoinsCovered} className="ach-icon" alt="" />
          <h3 className="ach-count">+100</h3>
          <p className="ach-text">Crypto Coins Covered</p>
        </div>
      </div>

    </div>
  </div>
</section>

{/* WHY PARTNER SECTION */}
<section className="partner-section">
  <h2 className="partner-title">Why Partner With CryptooAnts</h2>

  <div className="container">
    <div className="row partner-row">

      <div className="col-md-6 mb-3">
        <div className="partner-card">
          <img src={avatar} className="partner-icon" alt="" />
          <span>
            Community of <span style={{ fontWeight: "bold" }}>Verified Crypto experts</span>
          </span>
        </div>
      </div>

      <div className="col-md-6 mb-3">
        <div className="partner-card">
          <img src={rightArrow} className="partner-icon" alt="" />
          <span>
            Ready to Trade Ideas for{" "}
            <span style={{ fontWeight: "bold" }}>Beginners & Busy Professionals</span>
          </span>
        </div>
      </div>

      <div className="col-md-6 mb-3">
        <div className="partner-card">
          <img src={icon3} className="partner-icon" alt="" />
          <span>
            Ready to Plugin <span style={{ fontWeight: "bold" }}>B2B</span> Integration
          </span>
        </div>
      </div>

      <div className="col-md-6 mb-3">
        <div className="partner-card">
          <img src={icon4} className="partner-icon" alt="" />
          <span>
            <span style={{ fontWeight: "bold" }}>Unrestricted Data</span> & Unlimited Users
          </span>
        </div>
      </div>

    </div>
  </div>
</section>


{/* ABOUT US SECTION */}
<section className="about-section" id="about">
  <div className="container about-container">
    <div className="row align-items-center">

      <div className="col-md-6">
        <h2 className="about-title">About us</h2>
        <p className="about-text">
          CryptooAnts is a India’s first Crypto marketplace Platform, Where we cut the noise by scouting, training, verifying the crypto expert - to help with ready to plugin crypto price estimates to serve beginners/Busy Professionals participates actively in crypto markets.
        </p>

        <p className="about-text">
          Founded by a team passionate about democratizing financial intelligence, we connect retail traders, developers, and analysts — empowering confident trading for everyone.
        </p>
      </div>

      <div className="col-md-6 text-center">
        <img 
          src={aboutGroup} 
          className="about-img" 
          alt="Crypto Graphic"
        />
      </div>

    </div>
  </div>
</section>

{/* CONTACT CTA SECTION */}
<section className="unique-section" id="contact">
  <div className="container unique-wrapper">

    {/* LEFT IMAGE */}
    <div className="unique-left">
      <img
        src={Footerimg} 
        alt="Crypto 3D"
        className="unique-img"
      />
    </div>

    {/* RIGHT CONTENT */}
    <div className="unique-right">
      <h2 className="unique-title">
        Have a unique <br /> requirement?
      </h2>

      <p className="unique-subtitle">Let’s discuss it</p>
    </div>
<div className="partner-contact">
  <button className="unique-btn">
        Connect with Us <span className="unique-arrow">⬇</span>
      </button>

      <div className="unique-contact">
        <div className="unique-row">
          <img src={gmail} alt="mail" className="unique-icon" />
          partner@cryptooants.com
        </div>

        <div className="unique-row">
          <img src={require("../images/LandingPage/phone.jpeg")} alt="phone" className="unique-icon" />
          9321765323
        </div>
      </div>
</div>
  </div>
</section>

{/* DISCLAIMER SECTION */}
<section className="disclaimer-section">
  <div className="container">
    <h3 className="disclaimer-title">Disclaimer</h3>

    <p className="disclaimer-text">
      CryptooAnts is a marketplace for crypto price estimates. All price predictions, recommendations,
      and analytics are provided on an “as is” basis—without warranty or guarantee of any kind.
    </p>

    <p className="disclaimer-text">
      CryptooAnts does not provide investment advice, portfolio management, or personalized guidance.
      All content is solely informational, and the responsibility for investment decisions lies with the user.
      Past performance is not indicative of future results; the cryptocurrency market is inherently risky and volatile.
    </p>

    <p className="disclaimer-text">
      While we strive to maintain accuracy and update recommendations in real-time, CryptooAnts is not liable for losses
      incurred from acting on published content, delays in data, or service outages.
    </p>

    <p className="disclaimer-text">
      By using CryptooAnts, you acknowledge the speculative nature of crypto markets and agree to use the platform
      at your own risk. Users are strongly advised to perform their own independent due diligence and seek advice
      from registered financial professionals before making any trades based on CryptooAnts’ signals.
    </p>
  </div>
  
</section>

<section className="faq-section">
      <div className="container">
<div className="footer-divider"></div>
        <h3 className="faq-title">Frequently Asked Questions</h3>

        <div className="faq-item">
          <h4 className="faq-question">What is CryptooAnts Premium?</h4>
          <p className="faq-answer">
            CryptooAnts Premium is a structured module where verified experts publish crypto
            recommendations (perpetual futures – intraday, swing, or quarterly). All recommendations
            follow predefined parameters to maintain quality and consistency.
          </p>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">Who qualifies as a verified crypto expert?</h4>
          <p className="faq-answer">
            Verified Crypto Analysts are experts who have built a performance track record on the
            platform. Their recommendations are monitored, and sustained accuracy earns them a
            Verified Tick Mark.
          </p>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">What kind of recommendations can be published?</h4>
          <p className="faq-answer">
            Experts can publish directional trades on leading crypto assets (Top 50–100 tokens),
            including entry range, stop loss, and target levels.
          </p>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">What is the typical structure of a recommendation?</h4>
          <ul className="faq-list">
            <li>Token Name</li>
            <li>Contract Type</li>
            <li>Trade Direction (Long / Short)</li>
            <li>Entry Range</li>
            <li>Targets (T1 & T2)</li>
            <li>Stop Loss Levels</li>
            <li>Trade Validity</li>
            <li>Chart Snapshot & Tags</li>
          </ul>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">Can experts edit or manage past recommendations?</h4>
          <p className="faq-answer">
            Yes. Experts can view and edit their previously published recommendations from their
            dashboard. Deletions/archivals are handled by the CryptooAnts admin team.
          </p>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">What is CryptooBuzz?</h4>
          <p className="faq-answer">
            CryptooBuzz is an internal research and insights publishing tool for verified experts to
            share updates, news, and research with B2B partners.
          </p>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">Are expert posts visible to the public?</h4>
          <p className="faq-answer">
            CryptooBuzz posts are not visible publicly on the website. Distribution is handled via the
            admin panel.
          </p>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">What content formats are supported on CryptooBuzz?</h4>
          <ul className="faq-list">
            <li>Text-based insights</li>
            <li>Images (charts or visuals)</li>
            <li>Trade Direction (Long / Short)</li>
            <li>PDF or DOC reports</li>
            <li>Multiple formats can be combined in a single post.</li>
          </ul>
        </div>

        <div className="faq-item">
          <h4 className="faq-question">Can experts download or access their published material?</h4>
          <p className="faq-answer">
            Yes. Experts can download their own content as a zip file containing the text, images, and attachments.
          </p>
        </div>

      </div>
    </section>

     <section className="footer-section">
      <div className="container">

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Middle Row */}
        <div className="footer-row">
        <div>
        <p></p>
        </div>
          {/* Text Section */}
          <div className="footer-text">
            <p>@Initiative in CryptoMarkets by Established Brand StockAnts</p>
            <p>© 2025 CryptooAnts. All rights reserved.</p>
          </div>

          {/* Social Icons */}
          <div className="footer-social">
            <div className="footer-follow-text">Follow us on</div>

            <a href="#" className="footer-icon">
              <img src={facebook} alt="F" className="footer-social-img" />
            </a>

            <a href="#" className="footer-icon">
              <img src={instagram} alt="I" className="footer-social-img" />
            </a>

            <a href="#" className="footer-icon">
              <img src={linkedin} alt="Li" className="footer-social-img" />
            </a>

            <a href="#" className="footer-icon">
              <img src={twitter1} alt="X (Tw)" className="footer-social-img" />
            </a>
          </div>

        </div>
      </div>
    </section>
    </div>
  );
}
